import { render, staticRenderFns } from "./flagged-costs-lightbox.vue?vue&type=template&id=4178c9ea"
import script from "./flagged-costs-lightbox.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-lightbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4178c9ea')) {
      api.createRecord('4178c9ea', component.options)
    } else {
      api.reload('4178c9ea', component.options)
    }
    module.hot.accept("./flagged-costs-lightbox.vue?vue&type=template&id=4178c9ea", function () {
      api.rerender('4178c9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-lightbox/flagged-costs-lightbox.vue"
export default component.exports